import React from "react";
import { Helmet } from "react-helmet";
import { recordEvent } from "../components/Analytics";
import { navigate } from "../components/Router";
import { useSessionContext } from "../components/Session";
import { isBrowser } from "../components/Browser";
import Footer from "./Footer";
import MobileFooter from "./MobileFooter";
import Navbar from "containers/Navbar";
import AppPopUp from "containers/AppPopUp";

import log from "loglevel";

// import "../sass/app.scss";
import "../sass/common.scss";
import { LoadingText } from "./admin/LoadingText";
import { IS_PROD_STAGE } from "api-config";
import { anyCommonElements } from "components/SetUtil";
import { isAndroidOrIOSDevice } from "components/Features";

const DisableSeoIndex = () => (
  <Helmet>
    {/* Prevent Search Engine Indexing */}
    <meta name="robots" content="noindex" />{" "}
  </Helmet>
);

const LoadingPage = (props) => (
  <div className="global-wrapper">
    <DisableSeoIndex />
    <Navbar {...props} />
    <main>
      <LoadingText />
    </main>
    <Footer />
    <MobileFooter />
  </div>
);

const Layout = (props) => {
  const {
    location: { pathname, search, hash },
  } = props;
  const {
    children,
    isAdminPage,
    requireRole,
    allowedRoles,
    requireLoggedIn,
    disableSeoIndex,
    disableNavbar,
    disableFooter,
  } = props;
  const { sessionContext } = useSessionContext();
  const { isLoggedIn, isAdminUser, session } = sessionContext;
  const { email } = sessionContext.userInfo || {};
  const shouldDisableSeoIndex = disableSeoIndex || isAdminPage || requireRole || !IS_PROD_STAGE;
  const roles = session?.user?.roles || [];

  log.debug("Layout::render() props:", props);
  log.debug("Layout::isAdminPage:", isAdminPage);
  log.debug(`Layout:: isLoggedIn:${isLoggedIn} ${isAdminUser}`);

  if (!isLoggedIn && (isAdminPage || requireLoggedIn || requireRole)) {
    if (isBrowser()) {
      log.debug("Layout:: Not logged in, must be logged in.");
      const next = encodeURI(`${pathname}${search}${hash}`);
      navigate(`/login#${next}`);
    }
    // This runs in Node.js, when Gatsby is generating the assets on the server-side
    // We do this to prevent users who are not logged in from seeing a flash of the page
    // which they aren't supposed to see.
    return <LoadingPage {...props} />;
  }

  if (isLoggedIn && isAdminPage && !isAdminUser) {
    log.error(`Layout:: You don't have permission to view ${pathname}`);
    recordEvent({ name: "NotAuthorized", pathname, email });
    navigate(`/`);
    return <LoadingPage {...props} />;
  }

  if (isLoggedIn && requireRole && !roles.includes(requireRole)) {
    log.error(
      `Layout:: You don't have the required role "${requireRole}" to view ${pathname}`
    );
    recordEvent({ name: "NotAuthorized", pathname, email });
    navigate(`/`);
    return <LoadingPage {...props} />;
  }

  if (isLoggedIn && allowedRoles && !anyCommonElements(roles, allowedRoles)) {
    log.error(
      `Layout:: You don't have any of the allowed roles "${allowedRoles}" to view ${pathname}`
    );
    recordEvent({ name: "NotAuthorized", pathname, email });
    navigate(`/`);
    return <LoadingPage {...props} />;
  }

  return (
    <div className="global-wrapper">
      {shouldDisableSeoIndex && <DisableSeoIndex />}
      {!disableNavbar && <Navbar {...props} />}
      <main>{children}</main>
      {!disableFooter && <Footer />}
      <MobileFooter />
      {isAndroidOrIOSDevice() && <AppPopUp />}
    </div>
  );
};

export default Layout;
